// @ts-nocheck
// tool-shopify-pricing.js — Shopify Pricing Calculator behaviour (SSM-636).
//
// All rate data and cost math comes from window.SheroPlans (assets/tool-shopify-plans.js).
// Nothing numeric is written down here.
//
// Writes values into markup that snippets/tool-shopify-pricing.liquid already rendered
// and reveals pre-rendered variants. It never builds DOM and never touches the <option>
// lists — the selects in the Liquid are their only source.
(function () {
  var roots = document.querySelectorAll('[data-tool="shopify_pricing"]');
  if (!roots.length) return;

  var P = window.SheroPlans;
  if (!P) return; // tool-shopify-plans.js must load first; defer preserves order.

  var CUSTOM = 'other';

  // Two fraction digits: this is money derived from a rate.
  function usd(n) {
    return n.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  // Blank, not zero. With no revenue or AOV there is no honest total to print, and
  // printing the bare subscription is what made a $500,000/mo merchant see "$105.00".
  var BLANK = '—';

  function money(n) {
    return n == null || !isFinite(n) ? BLANK : usd(n);
  }

  function int(n) {
    return n == null || !isFinite(n) ? BLANK : n.toLocaleString('en-US');
  }

  // Subscriptions and thresholds: cents are noise.
  function whole(n) {
    return isFinite(n)
      ? n.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })
      : '$0';
  }

  function parseNum(raw) {
    var cleaned = String(raw).replace(/[^0-9.]/g, '');
    if (cleaned === '') return null;
    var n = Number(cleaned);
    return isFinite(n) && n >= 0 ? n : null;
  }

  function numOr0(raw) {
    var n = parseNum(raw);
    return n == null ? 0 : n;
  }

  function mount(root) {
    if (root.dataset.toolMounted) return;
    root.dataset.toolMounted = 'true';

    var fields = {};
    root.querySelectorAll('[data-spc-input]').forEach(function (el) {
      fields[el.getAttribute('data-spc-input')] = el;
    });
    if (!fields.plan || !fields.tier || !fields.aov) return;

    var out = {};
    root.querySelectorAll('[data-spc-out]').forEach(function (el) {
      out[el.getAttribute('data-spc-out')] = el;
    });

    var customWrap = root.querySelector('[data-spc-custom]');
    var emptyNote = root.querySelector('[data-spc-empty]');
    var announce = root.querySelector('[data-spc-announce]');
    var savingsBox = root.querySelector('[data-spc-savings]');
    var rateClause = root.querySelector('[data-spc-rate-clause]');
    var plusGapBox = root.querySelector('[data-spc-plusgap]');
    var annualNote = root.querySelector('[data-spc-annual-note]');
    var periodBtns = root.querySelectorAll('[data-spc-period]');
    var table = root.querySelector('[data-spc-table]');
    var verdictBox = root.querySelector('[data-spc-verdict]');
    var gateLine = root.querySelector('[data-spc-gate]');
    var plusRecNote = root.querySelector('[data-spc-plusrec]');
    var plusMore = root.querySelector('[data-spc-plus-more]');
    var plusCheaper = root.querySelector('[data-spc-plus-cheaper]');
    var plusCrossoverNote = root.querySelector('[data-spc-plus-crossover]');
    var plusHint = root.querySelector('[data-spc-plushint]');
    var toggles = root.querySelectorAll('[data-spc-toggle]');

    function pressed(name) {
      var el = root.querySelector('[data-spc-toggle="' + name + '"]');
      return !!(el && el.getAttribute('aria-pressed') === 'true');
    }

    var period = P.DEFAULT_PERIOD;
    var announceTimer = null;

    // Every field here ships with a real selected value, so these always resolve. They
    // stay optional in the markup anyway: a missing field falls back to the value that
    // constrains nothing, which reproduces the old cost-only ranking.
    function setup() {
      return {
        stores: fields.stores ? numOr0(fields.stores.value) : 1,
        staff: fields.staff ? numOr0(fields.staff.value) : 1,
        gateway: fields.gateway ? fields.gateway.value : P.DEFAULT_GATEWAY,
        needsCheckout: pressed('needsCheckout'),
        needsB2B: pressed('needsB2B'),
        needsIntl: pressed('needsIntl')
      };
    }

    // Names the field still missing. Totals stay blank until both revenue and AOV
    // exist, so a single generic prompt made picking a revenue look inert.
    function emptyPrompt(revenue, aov) {
      if (revenue > 0 && aov <= 0) return 'Now enter your average order value.';
      if (aov > 0 && revenue <= 0) return 'Now pick your monthly revenue.';
      return 'Pick a monthly revenue and enter your AOV to see your estimate.';
    }

    function set(key, value) {
      if (out[key]) out[key].textContent = value;
    }

    function cellsFor(planKey) {
      var row = root.querySelector('[data-spc-row="' + planKey + '"]');
      if (!row) return null;
      var map = { row: row };
      row.querySelectorAll('[data-spc-cell]').forEach(function (el) {
        map[el.getAttribute('data-spc-cell')] = el;
      });
      return map;
    }

    // ── Static figures, written once ───────────────────────────────────────
    function renderStatic() {
      set('ratesAsOf', P.RATES_AS_OF);
      set('ratesAsOf2', P.RATES_AS_OF);
      set('plusSub', whole(P.PLANS.plus.sub));
      set('plusSub2', whole(P.PLANS.plus.sub));
      // Read from the table rather than written into the copy, so the one-year Plus
      // price cannot drift while every other figure updates.
      set('plusSubOneYear', whole(P.PLANS.plus.subOneYear));
      set('plusSubOneYear2', whole(P.PLANS.plus.subOneYear));
      set('expansionFee', String(P.EXPANSION_STORE_FEE));
      set('plusThresholdAnnual', whole(P.PLUS_RECOMMENDED_ANNUAL));
      set('plusThresholdAnnual2', whole(P.PLUS_RECOMMENDED_ANNUAL));
      set('plusThresholdMonthly', whole(P.PLUS_RECOMMENDED_ANNUAL / 12));
      set('plusThresholdMonthly2', whole(P.PLUS_RECOMMENDED_ANNUAL / 12));
      set('plusThresholdAnnual3', whole(P.PLUS_RECOMMENDED_ANNUAL));
      set('plusFeeCrossover', whole(P.breakEvenRevenue('advanced', 'plus')));
      set('perOrderFee', P.PER_ORDER_FEE.toFixed(2));
      set('maxRateSaving', P.formatRate(P.maxRateSaving()));

      // Methodology rate table.
      P.PLAN_KEYS.forEach(function (key) {
        var plan = P.planFor(key);
        var row = root.querySelector('[data-spc-rate-row="' + key + '"]');
        if (!row) return;
        var c = {};
        row.querySelectorAll('[data-spc-rate]').forEach(function (el) {
          c[el.getAttribute('data-spc-rate')] = el;
        });
        if (c.name) c.name.textContent = plan.name;
        if (c.monthly) c.monthly.textContent = whole(plan.sub);
        if (c.annual) {
          c.annual.textContent = plan.annualSub === null ? 'Not published' : whole(plan.annualSub);
        }
        if (c.cardRate) {
          c.cardRate.textContent =
            P.formatRate(plan.rate) + '%' + (plan.rateIsEstimate ? ' (estimate)' : '');
        }
        if (c.perOrder) c.perOrder.textContent = '$' + plan.perOrder.toFixed(2);
      });
    }

    // ── Live render ────────────────────────────────────────────────────────
    function render() {
      var plan = fields.plan.value;
      var isCustom = fields.tier.value === CUSTOM;
      if (customWrap) customWrap.hidden = !isCustom;

      // `tier` holds the numeric string directly; the custom field replaces it.
      var revenue = isCustom ? numOr0(fields.customRevenue.value) : numOr0(fields.tier.value);
      var aov = numOr0(fields.aov.value);

      var req = setup();
      var input = {
        plan: plan,
        revenue: revenue,
        aov: aov,
        period: period,
        gateway: req.gateway,
        stores: req.stores,
        staff: req.staff,
        needsCheckout: req.needsCheckout,
        needsB2B: req.needsB2B,
        needsIntl: req.needsIntl
      };

      var result = P.calcResult(input);
      var comparison = P.comparePlans(input);
      var recommendation = P.recommendPlan(input);
      var breakEvens = P.adjacentBreakEvens(period, req.gateway);

      // The plan the tool recommends. From $1M a year in sales that is Shopify Plus,
      // whatever the fee totals say; below it, the cheapest plan the setup allows.
      // The cost difference is always shown next to it, never hidden.
      var plusByRevenue = comparison.hasInputs && P.isPlusRecommended(revenue);
      var recKey = plusByRevenue ? 'plus' : comparison.cheapestEligibleKey;

      function rowFor(key) {
        for (var k = 0; k < comparison.rows.length; k++) {
          if (comparison.rows[k].key === key) return comparison.rows[k];
        }
        return null;
      }

      set('orders', int(result.orders));
      set('txFees', money(result.txFees));
      set('total', money(result.total));
      set('footnote', result.footnote);
      set('captionPeriod', period);

      root.querySelectorAll('.tool-spc__stat-value').forEach(function (el) {
        el.setAttribute('data-dim', result.hasInputs ? 'false' : 'true');
      });
      if (emptyNote) emptyNote.hidden = result.hasInputs;
      set('emptyPrompt', emptyPrompt(revenue, aov));
      if (table) table.setAttribute('data-dim', comparison.hasInputs ? 'false' : 'true');

      comparison.rows.forEach(function (rowData) {
        var c = cellsFor(rowData.key);
        if (!c) return;
        var isSelected = rowData.key === plan;
        // Suppressed with no inputs: Basic is trivially cheapest on subscription
        // alone, which would read as a recommendation. Also withheld from a plan a
        // hard limit rules out, so the badge can never point at something unbuyable.
        var isCheapest = comparison.hasInputs && rowData.key === recKey;

        if (c.name) c.name.textContent = rowData.name;
        if (c.badgeYours) c.badgeYours.hidden = !isSelected;
        if (c.badgeCheapest) c.badgeCheapest.hidden = !isCheapest;
        if (c.blocked) {
          c.blocked.hidden = rowData.eligible;
          c.blocked.textContent = rowData.blockedBy || '';
        }
        if (c.sub) c.sub.textContent = whole(rowData.sub);
        if (c.noAnnual) c.noAnnual.hidden = rowData.subPublished;
        if (c.proc) {
          c.proc.textContent = comparison.hasInputs
            ? money(rowData.txFees)
            : P.formatRate(rowData.rate) + '%';
        }
        if (c.estRate) c.estRate.hidden = !rowData.rateIsEstimate;
        // Totals stay accurate for an ineligible plan; only the badge is withheld.
        if (c.total) c.total.textContent = comparison.hasInputs ? money(rowData.total) : BLANK;
        c.row.setAttribute('data-selected', isSelected ? 'true' : 'false');
        c.row.setAttribute('data-cheapest', isCheapest ? 'true' : 'false');
        c.row.setAttribute('data-blocked', rowData.eligible ? 'false' : 'true');
      });

      // ── Recommendation: cost line and gate line, never merged ──────────────
      // Withheld when the answer would be "drop off Plus". isPlusDowngrade exists to
      // stop the tool issuing that instruction, and a bold verdict line is the most
      // emphatic way to issue it. The neutral plus-gap note below carries it instead,
      // so the two can never contradict each other on screen.
      if (verdictBox) {
        var isDowngrade = recKey && P.isPlusDowngrade(plan, recKey);
        verdictBox.hidden = !recommendation.hasInputs || !recKey || isDowngrade;
        if (!verdictBox.hidden) {
          var recRow = rowFor(recKey);
          set('recPlan', P.PLANS[recKey].name);
          set('recTotal', money(recRow ? recRow.total : null));

          // Plus by revenue: say what it costs against the cheapest plan the setup
          // allows, and where Plus would win on fees alone.
          if (plusRecNote) plusRecNote.hidden = !plusByRevenue;
          if (plusByRevenue) {
            // Against the cheapest plan overall, not the cheapest the setup allows: a
            // toggle that rules out the lower plans must not make Plus look cheapest.
            var lowKey = comparison.cheapestKey;
            var lowRow = rowFor(lowKey);
            var extra = lowRow && recRow ? recRow.total - lowRow.total : 0;
            var plusIsCheapest = lowKey === 'plus' || extra <= 0.5;
            set('annualRevenue', whole(revenue * 12));
            set('plusExtra', whole(extra) + '/mo');
            set('plusVs', lowRow ? lowRow.name : '');
            set('plusCrossover', whole(P.breakEvenRevenue('advanced', 'plus', period, req.gateway)));
            if (plusMore) plusMore.hidden = plusIsCheapest;
            if (plusCheaper) plusCheaper.hidden = !plusIsCheapest;
            if (plusCrossoverNote) plusCrossoverNote.hidden = plusIsCheapest;
          }
          if (plusHint) plusHint.hidden = plusByRevenue || recKey === 'plus';

          // Shown only when a limit actually changed the answer, so it never
          // restates the cost line in different words. Not needed when revenue
          // already puts the merchant on Plus.
          var gated = !plusByRevenue && recommendation.gatedTo;
          if (gateLine) {
            gateLine.hidden = !gated;
            if (gated) {
              set(
                'gateReason',
                P.PLANS[recKey].name +
                  ', because ' +
                  (recommendation.blockedBy[recommendation.cheapestOverall] ||
                    'a plan limit rules out the cheaper option') +
                  '.'
              );
            }
          }
        }
      }

      // Break-even chips: fixed slots, revealed as many as there are pairs.
      root.querySelectorAll('[data-spc-chip]').forEach(function (chip, idx) {
        var be = breakEvens[idx];
        if (!be) {
          chip.hidden = true;
          return;
        }
        chip.hidden = false;
        var textEl = chip.querySelector('[data-spc-chip-text]');
        var approxEl = chip.querySelector('[data-spc-chip-approx]');
        // Plus is recommended on annual sales, not on the fee crossover, so its chip
        // shows the $1M threshold instead of the ~$760,000/mo fee break-even.
        var isPlusStep = be.to === 'plus';
        if (textEl) {
          textEl.textContent = isPlusStep
            ? be.fromName + ' → ' + be.toName + ' from ' + whole(P.PLUS_RECOMMENDED_ANNUAL) + ' a year'
            : be.fromName + ' → ' + be.toName + ' at ' + whole(be.revenue) + '/mo';
        }
        if (approxEl) approxEl.hidden = isPlusStep || !be.approximate;
      });

      // Guarded on the amount, not the key, so a few cents at a threshold cannot
      // produce a "save $0" nag. Leaving Plus is excluded here and handled below, so
      // this callout keeps exactly one meaning: a move the tool will recommend.
      // Targets the cheapest ELIGIBLE plan, so the tool never talks a merchant into a
      // move a hard limit rules out for them.
      var target = recKey;
      var savings = null;
      var plusGap = null;
      if (comparison.hasInputs && target && plan !== target) {
        var s = P.savingsBetween(plan, target, input);
        if (s.perMonth > 0.5) {
          if (P.isPlusDowngrade(plan, target)) {
            plusGap = s;
          } else {
            savings = s;
          }
        }
      }

      if (savingsBox) {
        savingsBox.hidden = !savings;
        if (savings) {
          set('savePerMonth', whole(savings.perMonth) + '/mo');
          set('savePerYear', whole(savings.perYear));
          set('saveFrom', P.PLANS[plan].name);
          set('saveTo', P.PLANS[target].name);
          set('saveTo2', P.PLANS[target].name);
          var rateSaving = P.rateSavingBetween(plan, target, req.gateway);
          if (rateClause) rateClause.hidden = !(rateSaving > 0);
          set('rateSaving', P.formatRate(rateSaving));
        }
      }

      if (plusGapBox) {
        plusGapBox.hidden = !plusGap;
        if (plusGap) {
          set('plusCheapest', P.PLANS[target].name);
          set('plusGapAmount', whole(plusGap.perMonth) + '/mo');
          set('plusFrom', P.PLANS[plan].name);
        }
      }

      if (annualNote) annualNote.hidden = period !== 'annual';

      // One short sentence for screen readers, debounced so typing "100000"
      // announces once rather than six times. Visible figures update per keystroke.
      var summary = comparison.hasInputs && target
        ? int(result.orders) +
          ' orders a month. ' +
          P.PLANS[plan].name +
          ' costs ' +
          money(result.total) +
          ' per month. ' +
          'We recommend ' +
          P.PLANS[target].name +
          ' at your numbers.' +
          (recommendation.gatedTo
            ? ' A plan limit rules out the cheaper option, see the note above.'
            : '') +
          (plusGap ? ' See the note below before moving off Shopify Plus.' : '')
        : '';
      clearTimeout(announceTimer);
      announceTimer = setTimeout(function () {
        if (announce) announce.textContent = summary;
      }, 500);
    }

    // ── Wiring ─────────────────────────────────────────────────────────────
    fields.plan.addEventListener('change', render);
    fields.aov.addEventListener('input', render);
    if (fields.customRevenue) fields.customRevenue.addEventListener('input', render);

    // Second input row. Optional markup, so every listener is guarded.
    ['stores', 'staff', 'gateway'].forEach(function (key) {
      if (fields[key]) fields[key].addEventListener('change', render);
    });

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var on = toggle.getAttribute('aria-pressed') === 'true';
        toggle.setAttribute('aria-pressed', on ? 'false' : 'true');
        render();
      });
    });

    // Switching off "Other" drops any custom figure, so a stale value can never be
    // read back if the shopper switches to it again.
    fields.tier.addEventListener('change', function () {
      if (fields.tier.value !== CUSTOM && fields.customRevenue) {
        fields.customRevenue.value = '';
      }
      render();
      if (fields.tier.value === CUSTOM && fields.customRevenue) {
        fields.customRevenue.focus();
      }
    });

    periodBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        // The billing period never mutates `plan`, and `plan` is never reassigned to
        // the cheapest plan. Two different concepts, kept apart so the table has one
        // source of truth.
        period = btn.getAttribute('data-spc-period');
        periodBtns.forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        render();
      });
    });

    renderStatic();
    render();
  }

  for (var i = 0; i < roots.length; i++) mount(roots[i]);
})();
